import React from 'react';
const Tier16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "10",
        height: "8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M9.271 2.438l-.93 4.636a.375.375 0 01-.367.301H2.026a.375.375 0 01-.368-.301L.73 2.438a.25.25 0 01.363-.27L3.36 3.376 4.774.358a.25.25 0 01.453 0L6.64 3.375l2.268-1.206a.25.25 0 01.362.27z"
    }));
Tier16.displayName = 'Tier16';
export default Tier16;

//# sourceMappingURL=16x16.js.map